import React, { useEffect } from 'react';
import Checkbox from '@mui/material/Checkbox';
import { Tooltip } from '@mui/material';

import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import EditOffOutlinedIcon from '@mui/icons-material/EditOffOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

export const CheckboxButton: React.FC<{
  icon: React.ReactNode;
  checkedIcon: React.ReactNode;
  tooltip: string;
  checked: boolean;
  dataTestId: string;
  onChange: (checked: boolean) => void;
}> = (props) => {
  const [checked, setChecked] = React.useState<boolean>(props.checked);

  useEffect(() => {
    setChecked(props.checked);
  }, [props.checked]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setChecked(event.target.checked);
    props.onChange(event.target.checked);
  };

  return (
    <Tooltip disableInteractive title={props.tooltip} placement="left">
      <Checkbox
        checked={checked}
        data-testid={props.dataTestId}
        size={'small'}
        onChange={handleChange}
        icon={props.icon}
        checkedIcon={props.checkedIcon}
        inputProps={{ 'aria-label': 'controlled' }}
        onClick={(event): void => event.stopPropagation()}
      />
    </Tooltip>
  );
};

export const EyeCheckboxButton: React.FC<{
  checked: boolean;
  onChange: (checked: boolean) => void;
}> = (props) => {
  return (
    <CheckboxButton
      dataTestId={'EyeBtn'}
      icon={<VisibilityOffOutlinedIcon />}
      checkedIcon={<VisibilityOutlinedIcon />}
      tooltip="Toggle visibility"
      checked={props.checked}
      onChange={props.onChange}
    />
  );
};

export const PenCheckboxButton: React.FC<{
  checked: boolean;
  onChange: (checked: boolean) => void;
}> = (props) => {
  return (
    <CheckboxButton
      dataTestId={'PenEditBtn'}
      icon={<EditOffOutlinedIcon />}
      checkedIcon={<EditOutlinedIcon />}
      tooltip="Toggle edit mode"
      checked={props.checked}
      onChange={props.onChange}
    />
  );
};
